import { createContext, useContext } from "react";

import { DocumentWriterHelper } from "./DocumentWriterHelper.ts";

export const DocumentWriterContext = createContext<DocumentWriterHelper>(
  {} as DocumentWriterHelper
);

export const useDocumentWriterContext = () => useContext(DocumentWriterContext);
